export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Hero background - image (video can be added later)
export const HERO_IMAGE = "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80";

// Theme 2 Background Image
export const THEME2_BG = "https://customer-assets.emergentagent.com/job_eduvisor/artifacts/3zctmidk_BG.png";

// Traffic Chart Colors
export const CHART_COLORS = ['#ef4444', '#f97316', '#eab308', '#22c55e', '#06b6d4', '#3b82f6', '#8b5cf6', '#ec4899'];

// Legacy emoji flags as fallback
export const countryFlagsEmoji = {
  "UK": "🇬🇧",
  "Denmark": "🇩🇰",
  "Netherlands": "🇳🇱",
  "Finland": "🇫🇮",
  "Canada": "🇨🇦",
  "Australia": "🇦🇺",
  "New Zealand": "🇳🇿",
  "Lithuania": "🇱🇹",
  "Hungary": "🇭🇺",
  "USA": "🇺🇸",
  "Germany": "🇩🇪",
  "Ireland": "🇮🇪",
  "France": "🇫🇷",
  "Sweden": "🇸🇪",
  "Norway": "🇳🇴"
};

// Translations
export const translations = {
  en: {
    heroTitle: "Discover Your Study Abroad Opportunities!",
    heroSubtitle: "Check your eligibility for UG/PG programs worldwide based on your academic level, GPA/CGPA & IELTS/PTE score",
    checkEligibility: "Check Your Study Eligibility",
    fullName: "Full Name",
    phone: "Phone",
    email: "Email",
    academicLevel: "Academic Level",
    subjectGroup: "Subject Group",
    yearOfPassing: "Year of Passing",
    gpa: "GPA",
    cgpa: "CGPA",
    applyingFor: "Applying For",
    englishTest: "English Proficiency Test",
    ieltsBand: "IELTS Overall Band",
    pteScore: "PTE Overall Score",
    checkBtn: "Check Eligibility",
    checking: "Checking... Hold a second",
    congratulations: "Congratulations! You are eligible for:",
    suggestions: "Suggestion & Note (Why not eligible)",
    contactConsultant: "Contact Our Consultant",
    sendMessage: "Send Message",
    sending: "Sending...",
    writeMessage: "Write your message...",
    studyGap: "Calculated study gap",
    years: "years",
    yes: "No Test",
    no: "No",
    selectOption: "Select...",
    resetForm: "Check Again",
    resetFormTooltip: "Clear form and start over"
  },
  bn: {
    heroTitle: "আপনার বিদেশে পড়ার সুযোগ আবিষ্কার করুন!",
    heroSubtitle: "আপনার একাডেমিক লেভেল, GPA/CGPA এবং IELTS/PTE স্কোরের ভিত্তিতে বিশ্বব্যাপী UG/PG প্রোগ্রামগুলির জন্য আপনার যোগ্যতা যাচাই করুন",
    checkEligibility: "আপনার স্টাডি এলিজিবিলিটি চেক করুন",
    fullName: "পুরো নাম",
    phone: "ফোন",
    email: "ইমেইল",
    academicLevel: "একাডেমিক লেভেল",
    subjectGroup: "সাবজেক্ট গ্রুপ",
    yearOfPassing: "পাশের সাল",
    gpa: "জিপিএ",
    cgpa: "সিজিপিএ",
    applyingFor: "আবেদনের জন্য",
    englishTest: "ইংরেজি দক্ষতা পরীক্ষা",
    ieltsBand: "IELTS Overall Band",
    pteScore: "PTE Overall Score",
    checkBtn: "এলিজিবিলিটি চেক করুন",
    checking: "চেক করা হচ্ছে... অপেক্ষা করুন",
    congratulations: "অভিনন্দন! আপনি নিম্নলিখিত দেশগুলোতে এলিজিবল:",
    suggestions: "পরামর্শ ও নোট (কেন যোগ্য নন)",
    contactConsultant: "আমাদের কন্সালট্যান্টের সাথে যোগাযোগ করুন",
    sendMessage: "মেসেজ পাঠান",
    sending: "পাঠানো হচ্ছে...",
    writeMessage: "আপনার মেসেজ লিখুন...",
    studyGap: "ক্যালকুলেটেড স্টাডি গ্যাপ",
    years: "বছর",
    yes: "টেস্ট নেই",
    no: "না",
    selectOption: "নির্বাচন করুন...",
    resetForm: "আবার চেক করুন",
    resetFormTooltip: "ফর্ম খালি করে নতুন করে শুরু করুন"
  }
};
